import React from "react"
import { SensaiComponentCardsBoxedText } from "../../../gql/generated/graphql"
import { Box } from "@mui/system"
import { Divider, Typography } from "@mui/material"
import { GatsbyImage } from "gatsby-plugin-image"
import ContentButton from "./ContentButton"
import theme from "../../../material-ui/theme"

const BoxedTextCard = ({ card }: { card: SensaiComponentCardsBoxedText }) => {
  const { id, title, description, backgroundImage, link, cardStyle } = card
  const dark = cardStyle?.style === "dark"
  return (
    <Box
      data-aos="flip-left"
      sx={{
        padding: "1.5rem",
        borderRadius: "1rem",
        position: "relative",
        display: "flex",
        flexDirection: "column",
        backgroundColor: dark
          ? "var(--color-dark-blue)"
          : "var(--color-bg-light)",
        ...(dark ? { color: "white" } : {}),
        width: "100%",
        ...(dark ? {} : { boxShadow: "0px 0px 4px #9a9a9a" }),
      }}
    >
      {backgroundImage && (
        <GatsbyImage
          image={backgroundImage.imageFile?.childImageSharp?.gatsbyImageData}
          style={{
            borderRadius: "1rem",

            overflow: "hidden",
            position: "absolute",
            bottom: 0,
            right: 0,
            top: 0,
            left: 0,
          }}
          objectFit="cover"
          objectPosition="50% 50%"
          alt={backgroundImage.alternativeText ?? ""}
        />
      )}

      <Box
        sx={{
          position: "relative",
          minHeight: "57.59px",
          display: "flex",
          alignItems: "center",
          [theme.breakpoints.down("lg")]: {
            minHeight: "48px",
            h4: {
              fontSize: "1.2rem !important",
              lineHeight: "1.5rem",
            },
          },
        }}
      >
        <Typography
          variant="h4"
          color={dark ? "white" : "var(--color-dark)"}
          fontSize={"1.5rem"}
          lineHeight={"1.8rem"}
          fontWeight={600}
        >
          {title}
        </Typography>
      </Box>
      <Divider
        sx={{
          width: "5.5rem",
          margin: "1rem 0",
          borderColor: "var(--color-teal)",
          borderWidth: "1px",
        }}
      />
      {description && <p style={{ zIndex: "2" }}>{description}</p>}
      <Box
        sx={{
          marginTop: "auto",
        }}
      >
        <ContentButton
          link={link ?? undefined}
          align={link?.type !== "cardArrow" ? "start" : "end"}
          margin="1rem 0 0 0 "
        />
      </Box>
    </Box>
  )
}

export default BoxedTextCard
